import { createAction, props } from '@ngrx/store';
import {DashboardItem} from '../../dashboard.model';

export const addDashboardStart = createAction('LANDINGPAGE::ADD_DASHBOARD_START', props<{ item: DashboardItem }>());
export const addDashboardSucceeded = createAction(
    'LANDINGPAGE::ADD_DASHBOARD_SUCCEEDED', props<{ item: DashboardItem }>()
);
export const addDashboardFailed = createAction('LANDINGPAGE::ADD_DASHBOARD_FAILED', props<{ error: Error }>());
